import React, { useEffect, useState } from 'react';
import './reference.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import {
  getFilterData,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getReferenceInformationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { loadNotificationTemplateById, loadNotificationTemplateRegistryList } from '../actions';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { dateTimeFormatter, statusFormatter, userPositionFormatter } from '../../../utils/formatters';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import NotificationTemplateRegistryPopUp from './NotificationTemplateRegistryPopUp';
import { NOTIFICATION_TEMPLATE_STATUS_LIST, NOTIFICATION_TEMPLATE_STATUS_NAMES } from '../../../configs';
import NotificationTemplateForm from './NotificationTemplateForm';
import { errorNotification } from '../../Notifications/notificationDecorator';
import NotificationTemplateRegistryDTO from '../../../dto/NotificationTemplateRegistryDTO';
import { getUsersData } from '../../User/reducer';
import { REFERENCE_INFORMATION_MODULE } from '../../../configs/moduleNames';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadUserList } from '../../User/actions';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function NotificationTemplateRegistry() {
  const dispatch = useDispatch();
  const store = useStore();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { updatePeriod } = useSelector(getSystemData);
  const DTO = new NotificationTemplateRegistryDTO();
  const attributes = DTO.getAttributesByName();

  const [searchParams, setSearchParams] = useSearchParams();
  const isNew = searchParams.get('new');
  const {
    notificationTemplateRegistryList = [],
    loadingNotificationTemplateRegistry = false,
    notificationTemplateRegistryListMeta = {},
    currentNotificationTemplate,
    loadingCreateNotification,
    loadingEditNotification,
    loadingCurrentNotificationTemplate,
  } = useSelector(getReferenceInformationData);
  const { loadingUserList } = useSelector(getUsersData);
  const { formatMessage } = useIntl();
  const columns = [
    {
      dataField: 'name',
      text: 'Наименование уведомления',
      headerClassName: 'notification-name-column',
    },
    {
      dataField: 'procedures',
      text: 'Применимая услуга',
      headerClassName: 'applicable-procedure-column',
      disableSort: true,
      formatter: a => {
        if (!a || !a.length) return null;
        return (
          <ul>
            {a.map((i, key) => (<li key={key}>{formatMessage({ id: `procedure.type.${i}` })}</li>))}
          </ul>
        );
      },
    },
    {
      dataField: 'created_at',
      text: 'Дата создания',
      headerClassName: 'creation-date-column',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'creator',
      text: 'Автор',
      headerClassName: 'author-column',
      formatter: userPositionFormatter,
      sortField: 'creator.full_name',
    },
    {
      dataField: 'status',
      text: 'Статус',
      headerClassName: 'status-column',
      formatter: (status, data) => statusFormatter(status || 0, 'notification.template.status', NOTIFICATION_TEMPLATE_STATUS_NAMES),
    },
  ];

  const {
    getValues, control, watch, setValue,
  } = useForm({ defaultValues: getFilterData('ntr-filter', {}) });
  const [sort, setSort] = useState(getDefaultSort(columns));
  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[REFERENCE_INFORMATION_MODULE].notificationTemplateRegistryListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: filterData,
      sort,
    };
    const p1 = dispatch(loadNotificationTemplateRegistryList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);
  useEffect(() => { setIsShowForm(!!isNew); setIsEdit(false); }, [isNew]);

  const handleEdit = item => event => {
    if (!item) {
      return;
    }
    handleClose();
    dispatch(loadNotificationTemplateById(item.id))
      .then(() => {
        setIsShowForm(true);
        setIsEdit(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
    return false;
  };

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadNotificationTemplateById(item.id))
      .then(() => {
        setIsShow(true);
        setSelectedRow(item);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
    return false;
  };

  const handleClose = () => {
    setIsShowForm(false);
    setIsEdit(false);
    setIsShow(false);
    setSelectedRow(null);
    setSearchParams({});
  };

  const handleDelete = () => {
    setIsShowForm(false);
    setIsEdit(false);
    setIsShow(false);
  };

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
        Просмотр
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
        Редактировать
      </Button>
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );
  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="page ntr-page">
      <TimerLoader loading={loadingNotificationTemplateRegistry || loadingCurrentNotificationTemplate || loadingUserList || loadingCreateNotification || loadingEditNotification || loadingCurrentNotificationTemplate} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.reference.notification.templates' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.status}
            options={NOTIFICATION_TEMPLATE_STATUS_LIST}
            addPlaceholder
            className="no-border"
          />
          <FieldDTO
            control={control}
            dtoObject={attributes.creator_id}
            usePortal
            className="no-border"
            addPlaceholder
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadUserList}
            optionFormatter={item => ({ value: item.id, name: item.full_name })}
            filterName="full_name"
          />
          <div className="filter-sep" />
          <Button variant="second" className="" onClick={() => { setIsShowForm(true); setIsEdit(false); }}>
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="plus"
            />
          </Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                onDoubleClickByRow={(item, e) => handleShow(item)(e)}
                rowClassFormatter={item => 'clickable-table-row'}
                data={notificationTemplateRegistryList}
                columns={columns}
                name="ntr-grid"
                className="ntr-grid"
                settingsFormatter={moreFormatter}
                renderContextMenu={renderContextMenu}
                changeSort={changeSort}
                sort={sort}
              />
            </div>
          </div>
          <Pagination meta={notificationTemplateRegistryListMeta} list={notificationTemplateRegistryList} handleChangeMeta={loadData} />
        </div>
      </div>
      {currentNotificationTemplate?.id && isShow ? <NotificationTemplateRegistryPopUp handleEdit={handleEdit} key={currentNotificationTemplate?.id} current={currentNotificationTemplate} handleDelete={handleDelete} close={handleClose} /> : null }
      {isShowForm ? <NotificationTemplateForm key={currentNotificationTemplate?.id} isEdit={isEdit} current={currentNotificationTemplate} loadData={loadData} close={handleClose} /> : null}
    </div>
  );
}
